import { types } from './userActions';

const initialState = {
    pending: false,
    payload: {},
    error: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.HTTP_PENDING_USER:
            return {
                ...state,
                pending: true
            }
        case types.HTTP_SUCCESS_USER:
            return {
                ...state,
                pending: false,
                payload: action.payload
            }

        case types.HTTP_ERROR_USER:
            return {
                ...state,
                pending: false,
                error: action.error,
            }
        default:
            return state;
    }
}

